/** Chart.js colors derived from CSS variables (--wa-*) on :root */

export const defaultThemeColors = {
  grid: "rgba(42, 57, 66, 0.65)",
  tick: "rgb(134, 150, 160)",
  legend: "rgb(233, 237, 239)",
  line: "rgb(0, 168, 132)",
  fill: "rgba(0, 168, 132, 0.22)",
  tooltipBg: "rgb(32, 44, 51)",
  tooltipBorder: "rgb(42, 57, 66)",
};

const normalizeRgbParts = (spaceSeparatedRgb) => {
  if (!spaceSeparatedRgb || typeof spaceSeparatedRgb !== "string") {
    return null;
  }
  const parts = spaceSeparatedRgb
    .trim()
    .split(/\s+/)
    .map((part) => Number(part))
    .filter((part) => Number.isFinite(part));
  return parts.length >= 3 ? parts.slice(0, 3) : null;
};

const toRgb = (spaceSeparatedRgb, fallback) => {
  const parts = normalizeRgbParts(spaceSeparatedRgb);
  if (!parts) return fallback;
  return `rgb(${parts.join(", ")})`;
};

const toRgba = (spaceSeparatedRgb, alpha, fallback) => {
  const parts = normalizeRgbParts(spaceSeparatedRgb);
  if (!parts) return fallback;
  return `rgba(${parts.join(", ")}, ${alpha})`;
};

export const readThemeColors = () => {
  if (typeof window === "undefined") {
    return defaultThemeColors;
  }
  const styles = window.getComputedStyle(document.documentElement);
  const border = styles.getPropertyValue("--wa-border");
  const muted = styles.getPropertyValue("--wa-muted");
  const text = styles.getPropertyValue("--wa-text");
  const accent = styles.getPropertyValue("--wa-accent");
  const panel = styles.getPropertyValue("--wa-panel");
  const isDark = document.documentElement.classList.contains("dark");
  const lineColor = isDark ? toRgb(accent, defaultThemeColors.line) : "rgb(196, 181, 253)";

  return {
    grid: toRgba(border, 0.65, defaultThemeColors.grid),
    tick: toRgb(muted, defaultThemeColors.tick),
    legend: toRgb(text, defaultThemeColors.legend),
    line: lineColor,
    fill: isDark ? toRgba(accent, 0.22, defaultThemeColors.fill) : "rgba(196, 181, 253, 0.26)",
    tooltipBg: toRgb(panel, defaultThemeColors.tooltipBg),
    tooltipBorder: toRgb(border, defaultThemeColors.tooltipBorder),
  };
};
